module.exports = __webpack_public_path__ + "static/media/education-object-0-1-0.213664d6.png";